import {
  BuildEnvironment,
  parseBooleanVariableOrFail,
  parseStringVariableOrFail,
} from 'project-conf'

export const IS_STAGING_BUILD_ENV = process.env.BUILD_ENV === BuildEnvironment.staging
export const IS_PRODUCTION_BUILD_ENV = process.env.BUILD_ENV === BuildEnvironment.production
export const BACKEND_API_URL = parseStringVariableOrFail(process.env, 'BACKEND_API_URL')
export const BUILD_ENV = parseStringVariableOrFail(process.env, 'BUILD_ENV') as BuildEnvironment
export const DATADOG_APPLICATION_ID = parseStringVariableOrFail(
  process.env,
  'DATADOG_APPLICATION_ID'
)
export const DATADOG_CLIENT_TOKEN = parseStringVariableOrFail(process.env, 'DATADOG_CLIENT_TOKEN')
export const DATADOG_SERVICE_NAME = parseStringVariableOrFail(process.env, 'DATADOG_SERVICE_NAME')

export const GTM_ID = parseStringVariableOrFail(process.env, 'GTM_ID')
export const GTM_PREVIEW_ID = parseStringVariableOrFail(process.env, 'GTM_PREVIEW_ID')
export const GTM_AUTH_CODE = parseStringVariableOrFail(process.env, 'GTM_AUTH_CODE')
export const IS_BUILD_OPTIMIZED = parseBooleanVariableOrFail(process.env, 'IS_BUILD_OPTIMIZED')

export const IS_CROSS_DOMAIN_COOKIE_ENABLED = parseBooleanVariableOrFail(
  process.env,
  'IS_CROSS_DOMAIN_COOKIE_ENABLED'
)
export const IS_DATADOG_ENABLED = parseBooleanVariableOrFail(process.env, 'IS_DATADOG_ENABLED')
export const IS_DYNAMIC_FLAGS_FETCHING_ENABLED = parseBooleanVariableOrFail(
  process.env,
  'IS_DYNAMIC_FLAGS_FETCHING_ENABLED'
)
export const IS_PRIVATE_LOG_ENVIRONMENT = parseBooleanVariableOrFail(
  process.env,
  'IS_PRIVATE_LOG_ENVIRONMENT'
)
export const VERSION = parseStringVariableOrFail(process.env, 'VERSION')

export const IS_ZENDESK_SIMULATED = parseBooleanVariableOrFail(process.env, 'IS_ZENDESK_SIMULATED')

/**
 * This will allow SITEKEY override for debugging turnstile on staging env: please remove me as soon as possible
 */
export const TURNSTILE_SITEKEY = (function (): string {
  const originalValue = parseStringVariableOrFail(process.env, 'TURNSTILE_SITEKEY')
  if (IS_PRODUCTION_BUILD_ENV) {
    return originalValue
  } else {
    const urlParams = new URLSearchParams(window.location.search)
    const siteKeyOverride = urlParams.get('TURNSTILE_SITEKEY')

    return siteKeyOverride || originalValue
  }
})()

export const LAUNCHDARKLY_CLIENT_ID = parseStringVariableOrFail(
  process.env,
  'LAUNCHDARKLY_CLIENT_ID'
)

export const USERPILOT_TOKEN = parseStringVariableOrFail(process.env, 'USERPILOT_TOKEN')
